'use strict';
(function(angular) {
  angular.module('fetchtv.Directives')
    .directive('ftPackagesList', function() {
      return {
        replace: true,
        restrict: 'E',
        scope: {
          'packs': '=',
          'skinnyPackReferences': '=',
          'addRemoveOptionalPack': '=',
          /** Determines whether to display my packages
           * @type {Boolean} **/
          'myPackages': '=',
          /** Package filter function
           * @type {Function<Object>} **/
          'packagesFilter': '&',
          /** Determine whether promo pack only
           * @type {Boolean} **/
          'promotedPackOnly': '&',
        },
        controller: [
          '$scope',
          function(
            $scope,
          ) {
            if ($scope.packagesFilter === undefined) {
              $scope.packageListFilter = pack => {
                return !pack.optional;
              };
            } else {
              $scope.packageListFilter = $scope.packagesFilter();
            }
          },
        ],
        templateUrl: 'views/common/packages-list.html'
      };
    });
})(angular);

